import { DialogWrapper } from "Dialogs/wrapper";
import "Components/image-click-areas";

export class ViewModel extends DialogWrapper {
  /**
   * Конструктор модели представления для диалога областей первого клика
   * @param {Object} params - Параметры инициализации
   * @param {string} params.imageUrl - URL изображения
   * @param {Function} params.onSave - Функция обратного вызова для сохранения
   * @param {Array} params.areas - Массив существующих областей
   * @param {Object} [params.passedOriginalImageDimensions] - Optional pre-loaded dimensions {width, height}
   * @param {HTMLElement} element - DOM элемент диалога
   */
  constructor(params, element) {
    super(params, element);

    this.imageUrl = params.imageUrl;
    this.onSave = params.onSave;
    this.selectedArea = ko.observable(null);
    this.description = ko.observable(params.description || 'В статистике будет указано количество кликов по добавленным областям')

    this.isEditingLocked = ko.observable(ko.unwrap(params.isEditingLocked) || false);
    this.isFullBlocked = ko.observable(ko.unwrap(params.isFullBlocked) || false);
    this.onBlockedInteraction = params.onBlockedInteraction || function() { console.warn('onBlockedInteraction not provided to first-click-areas-sidesheet'); };

    this.registerUnlockedArea = (area) => {
      if (!area) {
        return;
      }
      if (ko.isObservable(area.isEditable)) {
        area.isEditable(true);
        return;
      }
      if (typeof area.isEditable !== "undefined") {
        area.isEditable = ko.observable(!!area.isEditable);
        area.isEditable(true);
        return;
      }
      area.isEditable = ko.observable(true);
    };
    this.canEditArea = (area) => {
      if (this.isFullBlocked()) {
        return false;
      }
      if (!this.isEditingLocked()) {
        return true;
      }
      if (!area) {
        return false;
      }
      return !!ko.unwrap(area.isEditable);
    };
    this.isAreaEditingLocked = (area) => !this.canEditArea(area);

    const passedDims = ko.unwrap(params.passedOriginalImageDimensions);
    if (passedDims && passedDims.width > 0 && passedDims.height > 0) {
      this.originalImageDimensions = ko.observable({ width: passedDims.width, height: passedDims.height });
    } else {
      this.originalImageDimensions = ko.observable({ width: 0, height: 0 });
      this.loadImageDimensions();
    }

    this.childDisplayedImageDimensions = ko.observable({ width: 0, height: 0 });
    this.scrollableProperties = ko.observable();

    this.setupAreaManagement();

    /**
     * Дополняет область дополнительными свойствами:
     * - pixelWidth - ширина области в пикселях
     * - pixelHeight - высота области в пикселях
     * - isSelected - выбрана ли область
     * - clickCount - количество кликов на область
     * - name - имя области
     * - x - позиция области по горизонтали
     * - y - позиция области по вертикали
     * @param {Object} area - Область
     * @returns {Object} Область с дополнительными свойствами
     */
    this.augmentAreaWithPixelComputeds = function (area) {
      if (!area) return area;
      if (typeof area.isEditable === "undefined") {
        area.isEditable = ko.observable(false);
      } else if (!ko.isObservable(area.isEditable)) {
        area.isEditable = ko.observable(!!area.isEditable);
      }
      const self = this;

      console.log("тест-первого-клика augmentAreaWithPixelComputeds", area);

      area.pixelWidth = ko
        .computed({
          read: function () {
            const original = self.originalImageDimensions();
            const shouldReturnDefaultValue =
              !area || !ko.isObservable(area.width) || !original || original.width === 0;

            if (shouldReturnDefaultValue) {
              return 10;
            }

            if (ko.unwrap(area.width) >= 1) {
              return original.width;
            }

            return Math.round(ko.unwrap(area.width) * original.width);
          },
          write: function (value) {
            if (!self.canEditArea(area)) {
              self.onBlockedInteraction();
              area.width.valueHasMutated();
              return;
            }
            const original = self.originalImageDimensions();
            if (!area || !ko.isObservable(area.width) || !original || original.width === 0) {
              return;
            }

            let newPixelWidth;
            const numValue = parseInt(value);

            if (value === "" || value === null || isNaN(numValue)) {
              newPixelWidth = 10;
            } else {
              newPixelWidth = Math.max(10, numValue);
            }

            newPixelWidth = Math.min(newPixelWidth, original.width);

            const currentX = ko.unwrap(area.x) || 0;
            const currentXPixels = currentX * original.width;

            if (currentXPixels + newPixelWidth > original.width) {
              const newXPixels = Math.max(0, original.width - newPixelWidth);
              area.x(newXPixels / original.width);
            }

            area.width(newPixelWidth / original.width);
          },
        })
        .extend({ notify: "always" });

      area.pixelHeight = ko
        .computed({
          read: function () {
            const original = self.originalImageDimensions();
            if (!area || !ko.isObservable(area.height) || !original || original.height === 0) {
              return 10;
            }

            if (ko.unwrap(area.height) >= 1) {
              return original.height;
            }

            return Math.round(ko.unwrap(area.height) * original.height);
          },
          write: function (value) {
            if (!self.canEditArea(area)) {
              self.onBlockedInteraction();
              area.height.valueHasMutated();
              return;
            }
            const original = self.originalImageDimensions();
            if (!area || !ko.isObservable(area.height) || !original || original.height === 0) {
              return;
            }

            let newPixelHeight;
            const numValue = parseInt(value);

            if (value === "" || value === null || isNaN(numValue)) {
              newPixelHeight = 10;
            } else {
              newPixelHeight = Math.max(10, numValue);
            }

            newPixelHeight = Math.min(newPixelHeight, original.height);

            const currentY = ko.unwrap(area.y) || 0;
            const currentYPixels = currentY * original.height;

            if (currentYPixels + newPixelHeight > original.height) {
              const newYPixels = Math.max(0, original.height - newPixelHeight);
              area.y(newYPixels / original.height);
            }

            area.height(newPixelHeight / original.height);
          },
        })
        .extend({ notify: "always" });

      if (!area.pixelWidth) area.pixelWidth = ko.observable(10);
      if (!area.pixelHeight) area.pixelHeight = ko.observable(10);

      area.displayName = ko.computed(() => {
        const name = ko.unwrap(area.name);
        if (name && name.trim() !== '') {
          return name;
        }
        const areaIndex = this.areas().indexOf(area) + 1;
        return `Область ${areaIndex}`;
      });
      return area;
    };

    this.areas = ko.observableArray([]);
    // Инициализируем начальные области, которые передаются в диалог
    const initialAreas = (params.areas || [])
      .map((areaData) => {
        try {
          const newArea = {
            id: areaData.id || this.generateAreaId(),
            name: ko.isObservable(areaData.name)
              ? areaData.name
              : ko.observable(areaData.name || ''),
            x: ko.isObservable(areaData.x) ? areaData.x : ko.observable(areaData.x || 0.1),
            y: ko.isObservable(areaData.y) ? areaData.y : ko.observable(areaData.y || 0.1),
            width: ko.isObservable(areaData.width)
              ? areaData.width
              : ko.observable(areaData.width || 0.2),
            height: ko.isObservable(areaData.height)
              ? areaData.height
              : ko.observable(areaData.height || 0.2),
            isSelected: ko.isObservable(areaData.isSelected)
              ? areaData.isSelected
              : ko.observable(areaData.isSelected || false),
            clickCount: ko.isObservable(areaData.clickCount)
              ? areaData.clickCount
              : ko.observable(areaData.clickCount || 0),
            isEditable: ko.isObservable(areaData.isEditable)
              ? areaData.isEditable
              : ko.observable(Boolean(areaData.isEditable)),
          };
          return this.augmentAreaWithPixelComputeds(newArea);
        } catch (e) {
          console.error("Error creating area:", e, areaData);
          return null;
        }
      })
      .filter((area) => area !== null);

    // Сохраняем исходное состояние областей (на момент открытия диалога)
    this.areas(initialAreas);
    this.originalAreasJSON = JSON.stringify(ko.toJS(this.areas()));

    this.imageScalePercent = ko.computed(() => {
      const original = this.originalImageDimensions();
      const displayed = this.childDisplayedImageDimensions();
      if (original && original.width > 0 && displayed && displayed.width > 0) {
        return Math.round((displayed.width / original.width) * 100);
      }
      return 0; // Default scale if dimensions are not available
    });
  }

  /**
   * Загружает размеры изображения
   * Создает новый объект Image и устанавливает обработчик onload
   * для получения полного размера изображения
   */
  loadImageDimensions() {
    if (!this.imageUrl()) return;

    const img = new Image();
    img.onload = () => {
      this.originalImageDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    };
    img.src = ko.unwrap(this.imageUrl);
  }

  /**
   * Настраивает управление областями
   * Подписывается на изменения URL изображения и обновляет размеры при необходимости
   */
  setupAreaManagement() {
    // Следим за изменениями URL изображения
    if (ko.isObservable(this.imageUrl)) {
      this.imageUrl.subscribe(() => {
        this.loadImageDimensions();
      });
    }
  }

  /**
   * Обработчик изменения областей
   * Синхронизирует состояние областей и выделения между родительским и дочерним компонентами
   */
  onAreasChange() {
    this.areas.valueHasMutated();
    const currentSelection = this.selectedArea();
    if (currentSelection && this.areas.indexOf(currentSelection) === -1) {
      const stillExistsById = this.areas().find(
        (a) => a.id && currentSelection.id && ko.unwrap(a.id) === ko.unwrap(currentSelection.id)
      );
      if (stillExistsById) {
        this.selectedArea(stillExistsById);
      } else {
        this.selectedArea(this.areas().length > 0 ? this.areas()[0] : null);
      }
    }
  }

  /**
   * Добавляет новую область
   * Создает новую область с параметрами по умолчанию и добавляет ее в массив областей
   */
  addArea() {
    if (this.isFullBlocked()) {
      this.onBlockedInteraction();
      return;
    }
    const newAreaRaw = {
      id: this.generateAreaId(),
      name: ko.observable(''),
      x: ko.observable(0.4),
      y: ko.observable(0.4),
      width: ko.observable(0.2),
      height: ko.observable(0.2),
      isSelected: ko.observable(false),
      clickCount: ko.observable(0),
      isEditable: ko.observable(true),
    };
    const newArea = this.augmentAreaWithPixelComputeds(newAreaRaw);
    this.registerUnlockedArea(newArea);
    this.areas.push(newArea);
    this.selectedArea(newArea);
  }

  /**
   * Удаляет указанную область
   * @param {Object} area - Область для удаления
   */
  removeArea(area) {
    if (!this.canEditArea(area)) {
      this.onBlockedInteraction();
      return;
    }
    this.areas.remove(area);
    if (this.selectedArea() === area) {
      this.selectedArea(null);
    }
  }

  /**
   * Удаляет текущую выбранную область
   */
  removeSelectedArea() {
    const selected = this.selectedArea();
    if (!this.canEditArea(selected)) {
      this.onBlockedInteraction();
      return;
    }
    if (selected) {
      this.removeArea(selected);
    }
  }

  /**
   * Получает ширину области в пикселях
   * @param {Object} area - Область
   * @returns {number} Ширина в пикселях
   */
  getPixelWidth(area) {
    if (!this.canEditArea(area)) {
      this.onBlockedInteraction();
      return 50; // Значение по умолчанию
    }
    const original = this.originalImageDimensions();
    if (original.width === 0) return 50; // Значение по умолчанию
    return Math.round((ko.unwrap(area.width) || 0) * original.width);
  }

  /**
   * Получает высоту области в пикселях
   * @param {Object} area - Область
   * @returns {number} Высота в пикселях
   */
  getPixelHeight(area) {
    if (!this.canEditArea(area)) {
      this.onBlockedInteraction();
      return 50; // Значение по умолчанию
    }
    const original = this.originalImageDimensions();
    if (original.height === 0) return 50; // Значение по умолчанию
    return Math.round((ko.unwrap(area.height) || 0) * original.height);
  }

  /**
   * Устанавливает ширину области в пикселях
   * @param {Object} area - Область
   * @param {number} pixelWidth - Ширина в пикселях
   */
  setPixelWidth(area, pixelWidth) {
    if (!this.canEditArea(area)) {
      this.onBlockedInteraction();
      return;
    }
    const original = this.originalImageDimensions();
    if (original.width > 0) {
      area.width(pixelWidth / original.width);
    }
  }

  /**
   * Устанавливает высоту области в пикселях
   * @param {Object} area - Область
   * @param {number} pixelHeight - Высота в пикселях
   */
  setPixelHeight(area, pixelHeight) {
    if (!this.canEditArea(area)) {
      this.onBlockedInteraction();
      return;
    }
    const original = this.originalImageDimensions();
    if (original.height > 0) {
      area.height(pixelHeight / original.height);
    }
  }

  /**
   * Генерирует уникальный идентификатор для области
   * @returns {string} Уникальный идентификатор
   */
  generateAreaId() {
    return "area_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
  }

  /**
   * Получает информацию об области для отображения
   * @param {Object} area - Область
   * @returns {string} Строка с информацией о позиции и размере области
   */
  getAreaDisplayInfo(area) {
    const x = Math.round((ko.unwrap(area.x) || 0) * 100);
    const y = Math.round((ko.unwrap(area.y) || 0) * 100);
    const width = Math.round((ko.unwrap(area.width) || 0) * 100);
    const height = Math.round((ko.unwrap(area.height) || 0) * 100);

    return `${x}%, ${y}% (${width}% × ${height}%)`;
  }

  /**
   * Выбирает указанную область
   * @param {Object} areaToSelect - Область для выбора
   */
  selectArea(areaToSelect) {
    if (this.selectedArea() !== areaToSelect) {
      this.selectedArea(areaToSelect);
    }
  }

  /**
   * Сохраняет области
   * Вызывает функцию обратного вызова onSave и закрывает диалог
   */
  saveAreas() {
    if (typeof this.onSave === "function") {
      const areasData = ko.toJS(this.areas);
      this.onSave(areasData);
    }
    this.originalAreasJSON = JSON.stringify(ko.toJS(this.areas()));
    this.hide();
  }

  /**
   * Отменяет изменения
   * Восстанавливает области из исходного состояния и закрывает диалог
   */
  cancelChanges() {
    if (this.isEditingLocked() || this.isFullBlocked()) {
      this.hide();
      return;
    }
    const restoredAreasRaw = JSON.parse(this.originalAreasJSON);
    this.areas(
      restoredAreasRaw.map((areaData) => {
        const newArea = {
          id: areaData.id,
          name: ko.observable(areaData.name),
          x: ko.observable(areaData.x),
          y: ko.observable(areaData.y),
          width: ko.observable(areaData.width),
          height: ko.observable(areaData.height),
          isSelected: ko.observable(areaData.isSelected || false),
          clickCount: ko.observable(areaData.clickCount || 0),
          isEditable: ko.observable(Boolean(areaData.isEditable)),
        };
        return this.augmentAreaWithPixelComputeds(newArea);
      })
    );
    const currentSelectedId = this.selectedArea() ? ko.unwrap(this.selectedArea().id) : null;
    const newSelection =
      this.areas().find((a) => ko.unwrap(a.id) === currentSelectedId) ||
      (this.areas().length > 0 ? this.areas()[0] : null);
    this.selectedArea(newSelection);
    this.hide();
  }

  /**
   * Очищает все области
   * Удаляет все области и сбрасывает выделение
   */
  clearAllAreas() {
    if (this.isEditingLocked() || this.isFullBlocked()) {
      this.onBlockedInteraction();
      return;
    }
    this.areas.removeAll();
    this.selectedArea(null);
  }
}
